<kendo-multiselect [data]="data"
      [filterable]="true"
      textField="displayName"
      valueField="displayName"
      [value]="value"
      (valueChange)="onValueChange($event)"
      (filterChange)="this.filterChange.emit($event)"
      (open)="this.open.emit($event)"
      (close)="this.close.emit($event)"
      (focus)="this.focus.emit($event)"
      (blur)="this.blur.emit($event)"
      [disabled]="disabled"
      [loading]="loading"
      [placeholder]="placeholder"
    >
  <ng-template kendoMultiSelectItemTemplate let-dataItem>
    <span *ngIf="!dataItem.isAadGuest" [title]="dataItem.email || dataItem.login">{{dataItem.displayName}} <span class="dataItemTitle">({{dataItem.jobTitle}})</span></span>
    <span *ngIf="dataItem.isAadGuest" [title]="dataItem.email || dataItem.login">{{dataItem.displayName}} {{'aad_guest'|i18n}}</span>
  </ng-template>
  <ng-template kendoMultiSelectTagTemplate let-dataItem>
    <circ-person [person]="dataItem"></circ-person>
  </ng-template>
  <ng-template kendoMultiSelectNoDataTemplate>
    <span>{{ noDataText }}</span>
  </ng-template>
</kendo-multiselect>
